import { gql } from '@apollo/client'

export const LIST_BRANDS_PRODUCTS = gql`
  query {
    listSpecificBrands {
      name
      logoUrl
      urlStore
    }
  }
`
